import React, {useState} from "react";
import notfound from "../images/sticker-13.png";
// import { useInView } from "react-intersection-observer";
// import { useSessionStorage } from "./UIChatStorage";
const LazySticker = ({
  type,
  src,
  handleClick,
  id,
}: any) => {
  const [imageSrc, setImageSrc]: any = useState(src);
  const [isError, setIsError]: any = useState(false);
  const onLoad = (event: any) => {
    event.target.classList.add("loaded");
  };
  const onError = (event: any) => {
    event.target.classList.add("loaded");
    setImageSrc(notfound);
  };

  // useEffect(() => {
  //   console.log("id", id)
  // }, [id])
  //
  // useEffect(() => {
  //   console.log("src", src)
  // }, [src])

  return (
    <img
      id={type === "sticker" ? id : ""}
      width="100%"
      height="100%"
      src={process.env.PUBLIC_URL + (imageSrc.replace(process.env.PUBLIC_URL, ""))}
      onClick={type === "sticker" ? handleClick : undefined}
      onLoad={onLoad}
      onError={onError}
    />
  );
};
export default React.memo(LazySticker);
